export default __webpack_public_path__ + "static/media/Image20.121d2129.png";